module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container",
    staticStyle: {
      "position": "relative",
      "background": "#ffffff"
    }
  }, [_c('h2', {
    staticClass: "ui main header"
  }, [_vm._v("Boot Mieten")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "ui dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.$i18n.locale = 'de'
      }
    }
  }, [_c('i', {
    staticClass: "de flag"
  }), _vm._v(" Deutsch")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.$i18n.locale = 'en'
      }
    }
  }, [_c('i', {
    staticClass: "gb flag"
  }), _vm._v(" English")])])])]), _vm._v(" "), (_vm.bookingDisabled) ? _c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Buchung derzeit nicht möglich.\n        ")])]) : _c('div', [_c('div', {
    staticClass: "ui four large steps"
  }, [_c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 1
    }, {
      completed: _vm.selected.length > 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Boat & Time')))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Choose your boat and desired date and time'))
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 2
    }, {
      completed: _vm.detailsFormValid
    }, {
      disabled: _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_c('i', {
    staticClass: "list icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Details & Extras')))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Enter additional wishes'))
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 3
    }, {
      completed: _vm.formValid
    }, {
      disabled: !_vm.detailsFormValid || _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Contact Details')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('Enter contact details')))])])]), _vm._v(" "), _c('a', {
    staticClass: "step",
    class: [{
      active: _vm.step == 4
    }, {
      completed: _vm.step > 4
    }, {
      disabled: !_vm.formValid || _vm.selected.length == 0
    }],
    on: {
      "click": function($event) {
        _vm.step = 4
      }
    }
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Review & Confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t('Confirm your booking')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "right": "20px",
      "bottom": "20px",
      "z-index": "10"
    }
  }, [(_vm.step == 1) ? _c('button', {
    staticClass: "ui big primary button",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": function($event) {
        _vm.step = _vm.step + 1
      }
    }
  }, [(_vm.canContinue) ? _c('span', [_vm._v(_vm._s(_vm.$t('Accept & Continue')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Select slots to continue')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
    staticClass: "ui big icon primary button",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": _vm.goToContactDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Accept & Continue')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('button', {
    staticClass: "ui big icon primary button",
    class: {
      'disabled': !_vm.canContinue
    },
    on: {
      "click": _vm.goToConfirm
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Go To Confirmation')))]), _vm._v(" "), _c('i', {
    staticClass: "right arrow icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('button', {
    staticClass: "ui big icon primary button",
    on: {
      "click": _vm.confirmBooking
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Confirm Booking')))]), _vm._v(" "), _c('i', {
    staticClass: "checkmark icon"
  })]) : _vm._e()]), _vm._v(" "), (_vm.canBack) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "left": "20px",
      "bottom": "20px",
      "z-index": "10"
    }
  }, [_c('button', {
    staticClass: "ui negative big button",
    on: {
      "click": function($event) {
        _vm.step = _vm.step - 1
      }
    }
  }, [_c('i', {
    staticClass: "left arrow icon"
  }), _vm._v("\n            " + _vm._s(_vm.$t('Back')) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "beforeEnter": _vm.beforeAnimationEnter,
      "beforeLeave": _vm.beforeAnimationLeave
    }
  }, [(_vm.step == 1) ? _c('div', {
    key: "step1",
    staticStyle: {
      "position": "absolute",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('div', {
    staticClass: "item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Selected date')) + ":\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dateMinus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calendar item"
  }, [_c('div', {
    staticClass: "ui basic calendar"
  }, [_c('div', {
    staticClass: "ui huge icon input"
  }, [_c('i', {
    staticClass: "calendar icon"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "date",
      "placeholder": "Datum"
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.datePlus($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon arrow right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "item"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('Price for selected')) + ":\n                "), _c('div', {
    staticClass: "ui large blue basic label"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.selectedPrice))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui blue raised segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "segment"
    }
  }, [_c('h2', {
    staticClass: "ui red header"
  }, [_vm._v("\n                Buchungsbeginn zur vollen Stunde\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "72px"
      },
      attrs: {
        "id": hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n                    " + _vm._s(hour) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartFull), function(boat) {
    return _c('tr', {
      class: {
        'thick-border': _vm.boatsStartFull[_vm.boatsStartFull.indexOf(boat) - 1] && boat.type !== _vm.boatsStartFull[_vm.boatsStartFull.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      attrs: {
        "data-tooltip": "Click for details and pictures",
        "data-inverted": "true",
        "data-variation": "mini"
      },
      on: {
        "click": function($event) {
          _vm.showBoatDescription(boat)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(boat.name))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(boat.capacity.min) + "-" + _vm._s(boat.capacity.max) + " Pax - " + _vm._s(boat.price) + ",-€/Std.")]), _c('br')]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return _c('booking-choice', {
        key: hour.index,
        attrs: {
          "hour": hour,
          "boat": boat,
          "selected": _vm.selected,
          "date": _vm.date,
          "allBookings": _vm.allBookings,
          "bookingAllowedBefore": _vm.settings.bookingAllowedBefore,
          "clientId": _vm.clientId,
          "updatedBooking": _vm.updatedBooking
        },
        on: {
          "selected": _vm.selected
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    staticClass: "ruler",
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.$t('NOW')) + "\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui orange raised segment",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "80px"
    },
    attrs: {
      "id": "segment2"
    }
  }, [_c('h2', {
    staticClass: "ui red header"
  }, [_vm._v("\n                Buchungsbeginn zur halben Stunde\n              ")]), _vm._v(" "), _c('table', {
    staticClass: "ui definition celled bottom attached table",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "125px !important"
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "width": "72px !important"
      },
      attrs: {
        "id": hour === '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)
      }
    }, [_vm._v("\n                    " + _vm._s((parseInt(hour.split(' - ')[0]) - 1) + ':30')), _c('br'), _vm._v("-"), _c('br'), _vm._v(_vm._s((parseInt(hour.split(' - ')[1]) - 1) + ':30') + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.boatsStartHalf), function(boat) {
    return _c('tr', {
      class: {
        'thick-border': _vm.boatsStartHalf[_vm.boatsStartHalf.indexOf(boat) - 1] && boat.type !== _vm.boatsStartHalf[_vm.boatsStartHalf.indexOf(boat) - 1].type
      }
    }, [_c('td', {
      staticClass: "center aligned boat-title",
      attrs: {
        "data-tooltip": "Click for details and pictures",
        "data-inverted": "true",
        "data-variation": "mini"
      },
      on: {
        "click": function($event) {
          _vm.showBoatDescription(boat)
        }
      }
    }, [_c('div', {
      staticClass: "title",
      staticStyle: {
        "width": "110px"
      }
    }, [_vm._v(_vm._s(boat.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(boat.capacity.min) + "-" + _vm._s(boat.capacity.max) + " Pax - " + _vm._s(boat.price) + ",-€/Std.")]), _c('br')]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return _c('booking-choice', {
        key: hour.index,
        attrs: {
          "hour": hour,
          "boat": boat,
          "selected": _vm.selected,
          "date": _vm.date,
          "allBookings": _vm.allBookings,
          "bookingAllowedBefore": _vm.settings.bookingAllowedBefore,
          "clientId": _vm.clientId,
          "updatedBooking": _vm.updatedBooking
        },
        on: {
          "selected": _vm.selected
        }
      })
    })], 2)
  }))]), _vm._v(" "), (_vm.ruler.visible) ? _c('div', {
    staticClass: "ruler",
    style: ({
      width: '2px',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'red',
      top: '0px',
      left: _vm.ruler.left
    })
  }, [_c('span', [_vm._v("\n                " + _vm._s(_vm.$t('NOW')) + "\n              ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    key: "step2"
  }, [_c('div', {
    staticClass: "ui blue raised segments",
    staticStyle: {
      "position": "absolute",
      "margin-bottom": "80px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('ADDITIONAL DETAILS')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui very padded segment"
  }, [_c('form', {
    staticClass: "ui details large form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui relaxed grid"
  }, [_c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('How many guests will be on the boat(s)?')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.numPeople),
      expression: "details.numPeople"
    }],
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "number",
      "name": "numPeople",
      "min": "1",
      "step": "1",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.details.numPeople)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.numPeople = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('What\'s the reason for booking our boats?')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details._reason),
      expression: "details._reason"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.details._reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason._id
      }
    }, [_vm._v(_vm._s(reason.title))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui sixteen wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you require additional services?')))])]), _vm._v(" "), _vm._l((_vm.additionalServices), function(additionalService) {
    return _c('div', {
      staticClass: "service list item"
    }, [_c('div', {
      staticClass: "select"
    }, [_c('div', {
      staticClass: "ui basic tiny buttons"
    }, [(!additionalService.selected) ? _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Select\n                              ")]) : _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Remove\n                              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n                            " + _vm._s(additionalService.title) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                            " + _vm._s(additionalService.description) + "\n                          ")]), _vm._v(" "), (additionalService.letter === 'V') ? _c('br') : _vm._e(), _vm._v(" "), (additionalService.letter === 'V') ? _c('img', {
      staticStyle: {
        "height": "80px"
      },
      attrs: {
        "src": require("../assets/SNX3.jpg")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      class: {
        'strong': additionalService.selected
      }
    }, [_vm._v("€ " + _vm._s(_vm.numeral(additionalService.price).format('0,0.00'))), (additionalService.priceType === 'perPerson') ? _c('span', [_vm._v(" / person")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "large green checkmark icon",
      class: {
        'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected
      }
    })])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you have any additional wishes?')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.wishes),
      expression: "details.wishes"
    }],
    attrs: {
      "name": "wishes",
      "rows": "4",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.details.wishes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.wishes = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you have any additional questions?')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.questions),
      expression: "details.questions"
    }],
    attrs: {
      "name": "questions",
      "rows": "4",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.details.questions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.questions = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ui row"
  }, [_c('div', {
    staticClass: "ui eight wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Do you have a voucher code?')))]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.voucher),
      expression: "details.voucher"
    }],
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "text",
      "name": "voucher",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.details.voucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.voucher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "barcode icon"
  })])]), _vm._v(" "), (_vm.voucher) ? _c('div', {
    staticClass: "ui positive message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('Congratulations! You are eligible for discount.')) + "\n                          ")]), _vm._v(" "), _c('p', [_vm._v("A discount of\n                            "), _c('strong', [(_vm.voucher.deduct.percentage > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.percentage > 0 && _vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.absolute) + ".00€")]) : _vm._e()]), _vm._v("\n                            is applied to this booking.")])]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('div', {
    key: "step3"
  }, [_c('div', {
    staticClass: "ui blue raised segments",
    staticStyle: {
      "position": "absolute",
      "margin-bottom": "80px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('YOUR CONTACT DETAILS')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui padded segment"
  }, [_c('form', {
    staticClass: "ui contact-details form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmBooking($event)
      }
    }
  }, [_c('div', {
    staticClass: "ui relaxed grid"
  }, [_c('div', {
    staticClass: "seven wide column"
  }, [_c('div', {
    staticClass: "ui error message"
  }), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('Mr or Mrs')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Herr"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mr')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Frau"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mrs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('Select')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dr')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Prof"
    }
  }, [_vm._v(_vm._s(_vm.$t('Prof')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mag"
    }
  }, [_vm._v(_vm._s(_vm.$t('Mag')))])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('First Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.firstName),
      expression: "contact.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.contact.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Last Name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.lastName),
      expression: "contact.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.contact.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Company')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.company),
      expression: "contact.company"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "required field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.tel),
      expression: "contact.tel"
    }],
    attrs: {
      "type": "text",
      "name": "tel"
    },
    domProps: {
      "value": (_vm.contact.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.address),
      expression: "contact.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "ten wide field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('City')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.city),
      expression: "contact.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.contact.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six wide field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('Post Code')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.zip),
      expression: "contact.zip"
    }],
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.contact.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.zip = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.newsletterAccepted),
      expression: "contact.newsletterAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "newsletter"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.newsletterAccepted) ? _vm._i(_vm.contact.newsletterAccepted, null) > -1 : (_vm.contact.newsletterAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.newsletterAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.newsletterAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.newsletterAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.newsletterAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I agree to receive newsletter emails')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.photosAccepted),
      expression: "contact.photosAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "photos"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.photosAccepted) ? _vm._i(_vm.contact.photosAccepted, null) > -1 : (_vm.contact.photosAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.photosAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.photosAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.photosAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.photosAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I agree that my photos can be used for Meine Insel promotion')))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui inline checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.termsAccepted),
      expression: "contact.termsAccepted"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms"
    },
    domProps: {
      "checked": Array.isArray(_vm.contact.termsAccepted) ? _vm._i(_vm.contact.termsAccepted, null) > -1 : (_vm.contact.termsAccepted)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.contact.termsAccepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.contact.termsAccepted = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.contact.termsAccepted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contact.termsAccepted = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('I accept the')) + " "), _c('a', {
    attrs: {
      "href": "https://www.meine-insel.at/agb",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms of Service')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui nine wide column"
  }, [_c('div', {
    staticClass: "ui styled fluid accordion"
  }, [_c('div', {
    staticClass: "title active"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n                          Was passiert bei Schlechtwetter?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content active"
  }, [_c('p', [_vm._v("\n                            Definition: Als Schlechtwetter gilt... "), _c('br'), _vm._v(" 1. Wirklicher Niederschlag (Regen)"), _c('br'), _vm._v("2. Sturm\n                            (Mehr als Beaufort 5)"), _c('br'), _vm._v("3. Temperaturen unter 16 Grad Celsius\n                          ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Es gilt die Wettersituation auf der Alten Donau.\n                          ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Da die heurige Saison gezeigt hat, dass \"Transdanubien\" eine eigene Klimazone hat (z.B. bei\n                            Regen am Wienerberg oder in Hietzing trotzdem strahlender Sonnenschein an der Alten Donau),\n                            rufen Sie uns im Zweifel bitte ca. 3h vor Antritt der Fahrt an!\n                          ")]), _vm._v(" "), _c('p', [_vm._v("Wenn es wirklich regnet, gilt die Reservierung automatisch als kostenlos storniert. Sollte\n                            es stark bewölkt sein und nur eine Regenwahrscheinlichkeit bestehen, kann gefahren werden.\n                            Sollten Sie die Fahrt angetreten haben und der Regen während Ihrer Mietzeit eintreten,\n                            zahlen Sie selbstverständlich nur für die tatsächlich gefahrene Zeit.")])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n                          Mietzeit\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Unsere Boote werden stundenweise zur vollen Stunde vermietet.")]), _vm._v(" "), _c('p', [_vm._v("Bei einer Stunde Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,\n                            die letzten 5 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 45 Minuten.")]), _vm._v(" "), _c('p', [_vm._v("Bei zwei Stunden Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,\n                            die letzten 10 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 100 Minuten.")]), _vm._v(" "), _c('p', [_vm._v("Bei drei Stunden Mietzeit gelten die ersten 10 Minuten als Übergabe- und Einschulungszeit,\n                            die letzten 10 Minuten als Rücknahmezeit. Das ergibt eine Nettofahrzeit von 160 Minuten.")])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {
    key: "step4"
  }, [_c('div', {
    staticClass: "ui blue raised segment",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "margin-bottom": "80px",
      "padding-top": "50px",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "ui centered grid"
  }, [_c('div', {
    staticClass: "ui seven wide column"
  }, [_c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Please verify your booking and confirm.')) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui top attached segment"
  }, [_c('h4', [_vm._v(_vm._s(_vm.contact.title) + " " + _vm._s(_vm.contact.firstName) + " " + _vm._s(_vm.contact.lastName))]), _vm._v(" "), _c('p', [(_vm.contact.company) ? _c('span', [_vm._v(_vm._s(_vm.$t('Company')) + ": " + _vm._s(_vm.contact.company)), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.$t('Email')) + ": " + _vm._s(_vm.contact.email)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('Telephone')) + ": " + _vm._s(_vm.contact.tel)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('Address')) + ": " + _vm._s(_vm.contact.address)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('City')) + ": " + _vm._s(_vm.contact.city) + ", " + _vm._s(_vm.contact.zip) + "\n                    ")])]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('People')))]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("\n                        " + _vm._s(_vm.details.numPeople) + "\n                      ")])]), _vm._v(" "), _vm._l((_vm.selected), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(booking.boat.name) + "\n                      ")]), _vm._v(" "), _c('td', [(booking.boat.startsAtHalfHour) ? _c('span', [_vm._v("\n                          " + _vm._s((parseInt(booking.hour.split(' - ')[0]) - 1) + ':30') + " - " + _vm._s((parseInt(booking.hour.split(' - ')[1]) - 1) + ':30') + " h\n                        ")]) : _c('span', [_vm._v("\n                          " + _vm._s(booking.hour) + " h\n                        ")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n                        €" + _vm._s(booking.cost) + ".00\n                      ")])])
  }), _vm._v(" "), (_vm.voucher) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.code))])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.voucher.deduct.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.selectedPrice))])])]), _vm._v(" "), (_vm.additionalServices.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Services')))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.additionalServices), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n                        " + _vm._s(service.title))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson') ? _c('span', [_vm._v("p.P. €" + _vm._s(_vm.numeral(service.price).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.details.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Additional Wishes')))])])]) : _vm._e(), _vm._v(" "), (_vm.details.wishes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.details.wishes) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.details.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Questions')))])])]) : _vm._e(), _vm._v(" "), (_vm.details.questions) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.details.questions) + "\n                      ")])]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "ui big fluid primary button",
    on: {
      "click": _vm.confirmBooking
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Confirm Booking')))]), _vm._v(" "), _c('i', {
    staticClass: "checkmark icon"
  })])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "confirmModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Booking Confirmed\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            You will be notified by email.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui green ok inverted button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n              Okay\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "timeoutWarningModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Are you there?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Your booking session will expire in "), _c('strong', [_vm._v(_vm._s(_vm.settings.sessionTimeoutClear) + " seconds")]), _vm._v("! Press any\n            click to continue booking.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui inverted icon cancel button"
  }, [_c('i', {
    staticClass: "right arrow icon"
  }), _vm._v("\n              Continue booking\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic modal",
    attrs: {
      "id": "emailConfirmModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            Booking Confirmed\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Your booking was confirmed! An email was sent to you with all details and instructions.")]), _vm._v(" "), _c('p', [_vm._v("You can print this confirmation")]), _vm._v(" "), _c('booking-confirmation', {
    attrs: {
      "created-reservation": _vm.createdReservation
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui inverted icon cancel button"
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n              Close\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted icon button",
    on: {
      "click": _vm.printConfirmation
    }
  }, [_c('i', {
    staticClass: "print icon"
  }), _vm._v("\n              Print\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "boatDescriptionModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.describeBoat.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.describeBoat.description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui icon cancel button"
  }, [_vm._v("\n              Close\n            ")])])]), _vm._v(" "), _c('cancel-booking')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "de flag"
  }), _vm._v(" Deutsch")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b6a361e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking.vue
// module id = 737
// module chunks = 1